import { render, staticRenderFns } from "./LawNormViewStageTable.vue?vue&type=template&id=46b3328f"
import script from "./LawNormViewStageTable.vue?vue&type=script&lang=js"
export * from "./LawNormViewStageTable.vue?vue&type=script&lang=js"
import style0 from "./LawNormViewStageTable.vue?vue&type=style&index=0&id=46b3328f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports